<ng-container *ngIf="show">
    <button *ngIf="!opened" (click)="open()" mat-icon-button>
        <mat-icon [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
    </button>
    <div *ngIf="opened" class="absolute inset-0 flex items-center shrink-0 z-99 bg-card" @slideInTop @slideOutTop>
        <mat-icon class="absolute ml-6 sm:ml-8" [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
        <input class="w-full h-full px-16 sm:px-18"
               [formControl]="searchControl"
               [matAutocomplete]="matAutocomplete"
               [placeholder]="'Search...'"
               (keydown)="onKeydown($event)"
               #barSearchInput>
        <mat-autocomplete class="max-h-128 sm:px-2 border-t rounded-b shadow-md"
                          [autoSelectActiveOption]="true"
                          [disableRipple]="true"
                          #matAutocomplete="matAutocomplete">
        </mat-autocomplete>
        <button (click)="close()" class="absolute top-1/2 right-5 sm:right-7 shrink-0 w-10 h-10 -mt-5" mat-icon-button>
            <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div>
    <!-- <div *ngIf="opened" class="absolute inset-0 flex items-center shrink-0 z-99 bg-card" @slideInTop @slideOutTop>
        <mat-icon class="absolute ml-6 sm:ml-8" [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
        <input class="w-full h-full px-16 sm:px-18"
               [formControl]="searchControl"
               [matAutocomplete]="matAutocomplete"
               [placeholder]="'Search...'"
               (keydown)="onKeydown($event)"
               #barSearchInput>
        <mat-autocomplete class="max-h-128 sm:px-2 border-t rounded-b shadow-md"
                          [autoSelectActiveOption]="true"
                          [disableRipple]="true"
                          #matAutocomplete="matAutocomplete">
        </mat-autocomplete>
        <button (click)="close()" class="absolute top-1/2 right-5 sm:right-7 shrink-0 w-10 h-10 -mt-5" mat-icon-button>
            <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div> -->
</ng-container>
